import React from "react";

import ActionBar from "../components/ActionBar";
import Loader from "../components/Loader";
import VLButton from "../components/VLButton";
import * as API from "../util/api";
import * as Util from "../util/util";
import VLComponent from "./VLComponent";

class MatricesScreen extends VLComponent {

    constructor() {
        super();
        this.state = {loaded: false, matrices: [], page: 0};
    }

    componentDidMount() {
        this.reconnect();
    }

    reconnect = () => {
        API.POST("matrices/list", {}, result => {
            if (result.success) {
                this.setState(result.result);
                this.setState({loaded: true});
            }
        });
    };

    render() {
        return (
            <div>
                <ActionBar title="Matrix Views"/>
                {this.renderTextAlert()}
                <div id="content" style={{
                    display: this.state.loaded ? "flex" : "none",
                    width: "100%",
                    justifyContent: "center",
                    padding: 16
                }}>
                    <div style={{flex: 1}}>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <h1>Matrices</h1>
                            <div style={{flex: 1}}/>
                            {Util.isAdmin() && <VLButton href={"/matrices/-1"} title="Add View"/>}
                        </div>
                        {this.renderList()}
                    </div>

                </div>
                <Loader loaded={this.state.loaded}/>
            </div>
        );
    }

    renderList = () => {
        let styleTd = {padding: 8};
        return (
            <table style={{width: "100%"}} className="w3-table-all w3-table">
                <thead>
                <tr className="vl-theme">
                    <th style={styleTd}>Name</th>
                    <th style={styleTd}>Systems</th>
                    <th style={styleTd}/>
                    {Util.isAdmin() && <th style={styleTd}/>}
                    {Util.isAdmin() && <th style={styleTd}/>}
                </tr>
                </thead>
                <tbody>
                {this.state.matrices.map(this.renderItem)}
                </tbody>
            </table>
        );
    };

    renderItem = (user) => {
        let styleTd = {padding: 8};
        return (
            <tr>
                <td style={styleTd}>{user.name}</td>
                <td style={styleTd}>{user.cameras}</td>
                <td style={styleTd}><VLButton href={"/customMatrix/" + user.id} title="View"/></td>
                {Util.isAdmin() && <td style={styleTd}><VLButton href={"/matrices/" + user.id} title="Edit"/></td>}
                {Util.isAdmin() && <td style={styleTd}><VLButton onClick={() => this.deleteScreen(user)} title="Delete"
                                                                 style={{background: "red"}}/></td>}
            </tr>);
    };

    deleteScreen = screen => {
        if (window.confirm("Are you sure you want to delete " + screen.name)) {
            API.POST("matrices/delete", {id: screen.id}, result => {
                if (!result.success) {
                    this.basicAlert(result.error);
                    return;
                }
                this.reconnect();
            });
        }
    };

}

export default MatricesScreen;
